import { DISABLE_CREDIT_CARD_INFO_MODAL } from './types';
import { enableBodyScroll } from '../../util';

const disableCreditCardInfoModal = () => {
  enableBodyScroll();
  return { type: DISABLE_CREDIT_CARD_INFO_MODAL };
};

export default disableCreditCardInfoModal;



// WEBPACK FOOTER //
// ./src/actions/modals/disableCreditCardInfoModal.js